<div  #spdrow id="spdrow" style="opacity: 0; height:0px; width:100%;"></div>
@if (weatherData) {
  <div  style="margin-left: -1rem; margin-right: -1rem;" class="mb-3 {{theme$ | async}}">
    <div class="table-row d-flex p-0" style="width: 100%;">
      <div class="align-items-center justify-content-center item"
        [ngStyle]="unitsColumnStyle">
      </div>
      @for (data of weatherData; track $index; let first = $first; let last = $last) {
        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center item"
          [ngStyle]="first ? firstColumnStyle : last ? lastColumnStyle : {}">
          <i class="{{ data.icon | weatherIcon }} text-primary font-size-normal"></i>
          @if (!data.icon) {
            <div class="d-flex flex-grow-1 align-items-center justify-content-center text-primary">-</div>
          }
        </div>
      }
    </div>
    <div class="table-row d-flex p-0 text-primary font-size-small" style="width: 100%">
      <ng-container [ngTemplateOutlet]="units" [ngTemplateOutletContext]="{ unit: '°C' }"></ng-container>
      @for (data of weatherData; track $index; let first = $first; let last = $last) {
        @if (!!data.temperature == true) {
          <div
            class="d-flex flex-grow-1 align-items-center justify-content-center item smaller-font"
            [ngStyle]="first ? firstColumnStyle : last ? lastColumnStyle : {}">
          {{ !!data.temperature ? (data.temperature | number:'1.0-0' | customNumberFormat) : '-' }}</div>
        }
      }
    </div>
    <div class="table-row d-flex p-0 text-primary" style="width: 100%">
      <ng-container [ngTemplateOutlet]="units" [ngTemplateOutletContext]="{ unit: 'm/s' }"></ng-container>
      @for (data of weatherData; track $index; let first = $first; let last = $last) {
        @if (!!data.wind_speed == true) {
          <div
            class="d-flex flex-grow-1 align-items-center justify-content-center item smaller-font"
            [ngStyle]="first ? firstColumnStyle : last ? lastColumnStyle : {}">
          {{ !!data.wind_speed ? (data.wind_speed | number:'1.1-1' | customNumberFormat) : '-' }}</div>
        }
      }
    </div>
    <div class="table-row d-flex p-0 text-primary" style="width: 100%">
      <ng-container [ngTemplateOutlet]="units" [ngTemplateOutletContext]="{ unit: 'WD' }"></ng-container>
      @for (data of weatherData; track $index; let first = $first; let last = $last) {
        @if (data.wind_direction) {
          <div class="d-flex flex-grow-1 align-items-center justify-content-center item"
            tooltip="{{ (data.wind_direction||0) | number:'1.1-1' | customNumberFormat }}°" placement="top"
            [ngStyle]="first ? firstColumnStyle : last ? lastColumnStyle : {}">
            <i class="material-icons wind-icons" style="font-size: 1rem !important;" [ngStyle]="rotate(data.wind_direction)">navigation</i>
          </div>
        }
        @if (data.wind_direction == undefined) {
          <div
            class="d-flex flex-grow-1 align-items-center justify-content-center item"
          [ngStyle]="first ? firstColumnStyle : last ? lastColumnStyle : {}">-</div>
        }
      }
    </div>
  </div>
}


<ng-template #units let-unit="unit">
  <div class="d-flex align-items-center justify-content-center item smaller-font"
    [ngStyle]="unitsColumnStyle">
  {{unit}}</div>
</ng-template>
